const FULL_TURN = Math.PI * 2;

export function cameraDroneOrbitAngle(
  serverTimeMilliseconds: number,
  revolutionSeconds = 90,
  reducedMotion = false,
): number {
  if (reducedMotion) return 0.75;
  const duration = Math.max(1, revolutionSeconds * 1000);
  return ((((serverTimeMilliseconds % duration) + duration) % duration) / duration) * FULL_TURN;
}

export function cameraDroneTransitionProgress(
  elapsedMilliseconds: number,
  durationMilliseconds: number,
  reducedMotion = false,
): number {
  if (reducedMotion) return 1;
  const linear = Math.min(1, Math.max(0, elapsedMilliseconds / Math.max(1, durationMilliseconds)));
  return linear * linear * (3 - 2 * linear);
}
